import {ID} from './model';

export const domId = (id: ID, prefix?: string) => {
  const fullId = prefix ? `${prefix}-${id}` : `${id}`;
  return !fullId.match(/^[A-Za-z]/) ? id : fullId.replace(/[^A-Za-z_\d\-.:]/g, '-');
};
